import React, { useEffect, useState } from 'react';
import { Modal } from '../ui';
import type { PlatformTenant } from './TenantAccordionItem';

type CreateTenantAdminModalProps = {
  tenant: PlatformTenant | null;
  isSubmitting?: boolean;
  onClose: () => void;
  onSubmit: (payload: { name: string; email: string; password: string; role: 'ADMIN' }) => void;
};

export const CreateTenantAdminModal: React.FC<CreateTenantAdminModalProps> = ({
  tenant,
  onClose,
  onSubmit,
  isSubmitting
}) => {
  const open = Boolean(tenant);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (open) {
      setName('');
      setEmail('');
      setPassword('');
    }
  }, [open]);

  if (!tenant) return null;

  return (
    <Modal isOpen={open} onClose={onClose} title={`Crear admin — ${tenant.name}`}>
      <form
        className="space-y-3"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit({ name, email, password, role: 'ADMIN' });
        }}
      >
        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">Nombre</label>
          <input
            required
            aria-label="Nombre del administrador"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          />
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">Email</label>
          <input
            required
            type="email"
            aria-label="Email del administrador"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          />
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">Clave temporal</label>
          <input
            required
            minLength={6}
            type="password"
            aria-label="Clave temporal del administrador"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          />
        </div>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg px-4 py-2 text-sm text-slate-600 hover:bg-slate-100"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60"
          >
            {isSubmitting ? 'Creando…' : 'Crear admin'}
          </button>
        </div>
      </form>
    </Modal>
  );
};
